<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-landata g-main-wrapper">
      <!-- filter -->
      <land-filter placeholder="请输入落地页ID或名称查询" @on-change="filterData" @on-search="searchFilterData" />
      <!-- table -->
      <div class="c-table-list">
        <Viewport v-model="tableHeight">
          <land-table
            :loading="loading"
            :data="tableList"
            :columns="tableCol"
            :height="tableHeight"
            @on-refresh="getData"
            @on-preview="showView"
            @on-cdn="refreshData"
          />
          <Page
            show-total
            show-sizer
            show-elevator
            :total="total"
            :current.sync="pageIndex"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            @on-change="changePageIndex"
            @on-page-size-change="changePageSize"
            class="c-table-page"
            size="small"
          />
        </Viewport>
      </div>
      <pre-view v-model="model" :title="title" :src="src" :current="1"></pre-view>
    </div>
  </Layout>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/landata_column'
import { setLocal, getLocal } from '@/common/js/api'
import { getLandPage, refreshLandPage } from '@/api/landpage.model'
import LandTable from './components/land-table'
import LandFilter from './components/land-filter'
import PreView from './components/preview/layout'

export default {
  name: 'app',
  mixins: [mixin],
  components: { LandTable, LandFilter, PreView },
  methods: {
    getData(filter) {
      let params = {
        page_id: this.pageIndex,
        page_size: this.pageSize,
        orderColumn: this.sort,
        order: this.order
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      // 请求数据
      this.loading = true
      getLandPage(params)
        .then((data) => {
          this.loading = false

          if (data && data.list && data.page_info) {
            /* eslint-disable */
            const { total_number } = data.page_info
            this.total = total_number ? total_number : 0
            /* eslint-disable */
            this.tableList = data.list.map((ret) => {
              return ret
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('LAND_PAGESIZE', size)
    },
    showView({ url, title }) {
      this.model = true
      this.title = title
      this.src = url
    },
    refreshData(id) {
      refreshLandPage({ pageId: id }).then((data) => {
        if (data) this.$Message.success('刷新落地页成功！')
      })
    }
  },
  data() {
    return {
      tableHeight: 330,
      model: null,
      title: '',
      src: ''
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('LAND_PAGESIZE')) || 20
    this.tableCol = columns
    this.sort = 'create_time'
    this.order = 'desc'
  }
}
</script>
<style lang="scss" scoped>
.c-landata {
  height: 100%;
  padding: 8px 8px 0;
}

.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
